import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ accountTopicLabels: 'topicLabels/getTopicLabels' }),
    savedTopicLabels() {
      return this.$store.getters[
        'conversationTopicLabels/getConversationTopicLabels'
      ](this.conversationId);
    },
    activeTopicLabels() {
      return this.accountTopicLabels.filter(({ title }) =>
        this.savedTopicLabels.includes(title)
      );
    },
    inactiveTopicLabels() {
      return this.accountTopicLabels.filter(
        ({ title }) => !this.savedTopicLabels.includes(title)
      );
    },
  },
  methods: {
    addTopicLabelToConversation(value) {
      const result = this.activeTopicLabels.map(item => item.title);
      result.push(value.title);
      this.onUpdateTopicLabels(result);
    },
    removeTopicLabelFromConversation(value) {
      const result = this.activeTopicLabels
        .map(topic => topic.title)
        .filter(topic => topic !== value);
      this.onUpdateTopicLabels(result);
    },
    async onUpdateTopicLabels(selectedTopicLabels) {
      this.$store.dispatch('conversationTopicLabels/update', {
        conversationId: this.conversationId,
        topicLabels: selectedTopicLabels,
      });
    },
  },
};

